import * as React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import SortOrderContext from '@jetshop/core/components/SortOrder/SortOrderContext';
import t from '@jetshop/intl';
import { pushHistory } from '@jetshop/core/components/Filters/utils/updateHistory';
// Temporary sort type mapping until API returns this
export const sortTypes = {
    NAME: 'string',
    ARTICLE_NUMBER: 'number',
    PUBLISH_DATE: 'date',
    PRICE: 'number',
    SUB_HEADING: 'string',
    BESTSELLER: 'bestseller',
    CUSTOM: 'custom'
};
export const sortValues = {
    string: [
        {
            text: t('A to Z'),
            direction: 'ASCENDING'
        },
        {
            text: t('Z to A'),
            direction: 'DESCENDING'
        }
    ],
    number: [
        {
            text: t('low to high'),
            direction: 'ASCENDING'
        },
        {
            text: t('high to low'),
            direction: 'DESCENDING'
        }
    ],
    date: [
        {
            text: t(''),
            direction: 'DESCENDING'
        }
    ],
    bestseller: [
        {
            text: t(''),
            direction: 'DESCENDING'
        }
    ],
    custom: [
        {
            text: t(''),
            direction: 'ASCENDING'
        }
    ]
};
export function getSortOrderFromQueryString(search) {
    const parsedSearch = qs.parse(search, {
        ignoreQueryPrefix: true
    });
    if (Object.keys(parsedSearch).includes('orderBy')) {
        return {
            sortOrder: parsedSearch.orderBy,
            direction: parsedSearch.direction
        };
    }
}
export function updateSortOrderHistory({ value, direction, history, location }) {
    const currentSearch = qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {};
    const newSearch = Object.assign(Object.assign({}, currentSearch), { orderBy: value, direction });
    pushHistory({
        history,
        pathname: location.pathname,
        hash: location.hash,
        search: newSearch,
        resetPage: true,
        routeType: 'sortOrderChange'
    });
}
class SortOrderContainer extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = (value, direction) => {
            const { location, history } = this.props;
            updateSortOrderHistory({ location, history, value, direction });
            this.setState({ sortOrder: value, direction });
            return true;
        };
        this.state = {
            sortOrder: null,
            direction: 'DESCENDING',
            changeSortOrder: this.onSelect
        };
    }
    componentDidMount() {
        if (this.props.location.search) {
            const sortOrder = getSortOrderFromQueryString(this.props.location.search);
            if (sortOrder) {
                this.setState(sortOrder);
            }
        }
    }
    render() {
        return (React.createElement(SortOrderContext.Provider, { value: this.state }, this.props.children(this.state)));
    }
}
export default withRouter(SortOrderContainer);
//# sourceMappingURL=SortOrderContainer.js.map